const styleSheet = () => ({
  profile: {
    fontSize: '14px',
    color: '#223762 !important',
    display: 'flex',
    lineHeight: '22px',
    textDecoration: 'none',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    marginRight: '5px',
    height: '24px',
  },
  menuTitle: {
    height: '25px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '20px',
    fontWeight: 700,
    letterSpacing: '-0.2px',
    lineHeight: '25px',
    marginTop: '10px',
    marginBottom: '4px',
    display: 'inline-block',
  },
  heading: {
    height: '19px',
    width: 'auto',
    color: '#6373A4',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '19px',
    marginTop: '16px',
    marginBottom: '6px',
  },
  value: {
    height: '19px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0',
    lineHeight: '19px',
  },
  help: {
    height: '20px',
    display: 'inline-block',
    cursor: 'pointer',
    position: 'relative',
    top: '7px',
  },
  helpText: {
    paddingLeft: '4px',
    verticalAlign: 'top',
    position: 'relative',
    height: '18px',
    color: '#085FE5',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '11px',
    fontWeight: '500',
    letterSpacing: '0',
  },
  profileName: {
    paddingLeft: '3px',
    height: '18px',
    position: 'relative',
    color: '#051D39',
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '18px',
    textTransform: 'capitalize',
  },
  platforms: {
    display: 'block',
    paddingTop: '20px',
    '& li': {
      display: 'block !important',
      borderBottom: 'none',
      padding: '12px 0',
      '& a': {
        color: '#085FE5',
        fontSize: '14px',
      },
    },
  },
});

export default styleSheet;
